// 物料词库管理
import {contractApi} from "@/axios";
//获取词库信息
export function getLexiconPage(params,sendData){
    return contractApi({
        url:'/material-lexicon/page',
        method:'post',
        data:sendData,
        params:params
    })
}
//删除词库信息
export function deleteLexicon(params){
    return contractApi({
        url:'/material-lexicon',
        method:'delete',
        params:params
    })
}
//添加词库信息
export function addLexicon(data){
    return contractApi({
        url:'/material-lexicon',
        method:'post',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//修改词库信息
export function editLexicon(data){
    return contractApi({
        url:'/material-lexicon',
        method:'put',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}

export function getMaterialType(params){
    return contractApi({
        url:'/material-lexicon/get-material',
        method:'get',
        params:params
    })
}
//下载缩略图
export function attachmentAnnex(id) {
    return contractApi({
        url: '/material-lexicon/annex/' + id,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//更新物料状态
export function updateMaterialStatus(id,status){
    return contractApi({
        url:'/material-lexicon/update-status/'+id+ '/'+status,
        method:'put'
    })
}